module.exports = __webpack_public_path__ + "static/media/mental-awareness.e0b8b05b.svg";